<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.equipmentinfo_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload2"
          v-if="permission.equipmentinfo_delete"
          @click="openCllectionItem(scope.row)"
          >巡检项
        </el-button>
      </template>
    </avue-crud>
    <el-dialog title="巡检项" append-to-body :visible.sync="collectionItem" @closed="closedDialog">
      <avue-crud
        :data="inspectionItemData"
        v-model="inspectionItemForm"
        ref="inspectionItemFormRef"
        :option="inspectionItemOption"
        :page.sync="inspectionItemPage"
        @row-update="inspectionItemUpdate"
        @row-save="inspectionItemSave"
        @row-del="inspectionItemDel"
        @search-change="inspectionItemSearchChange"
        @current-change="inspectionItemCurrentChange"
        @size-change="inspectionItemSizeChange"
        @on-load="inspectionOnLoad"
        @refresh-change="inspectionOnLoad"
      >
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/equipment/equipmentinfo';
import { equipmentinfoOption } from './equipmentinfo-option.js';
import { mapGetters } from 'vuex';
import {
  inspectProjectAdd,
  inspectProjectGetList,
  inspectProjectRemove,
  inspectProjectUpdate,
} from '@/api/v4ward/inspectproject/inspectproject';
export default {
  data() {
    return {
      inspectionItemData: [],
      inspectionItemQuery: {},
      collectionItem: false,
      inspectionItemForm: {},
      inspectionItemPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: equipmentinfoOption,
      inspectionItemOption: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '设备名',
            prop: 'equipmentName',
            editDisplay: true,
            addDisplay: false,
            disabled: true,
          },
          {
            label: '巡检内容',
            type: 'textarea',
            prop: 'inspectContent',
            span: 24,
            row: 4,
            maxlength: 500,
            overHidden: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '巡检内容',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.equipmentinfo_add, false),
        viewBtn: this.vaildData(this.permission.equipmentinfo_view, false),
        delBtn: this.vaildData(this.permission.equipmentinfo_delete, false),
        editBtn: this.vaildData(this.permission.equipmentinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    closedDialog() {
      this.inspectionItemPage.currentPage = 1;
      this.inspectionItemPage.pageSize = 10;
      this.inspectionItemPage.total = 0;
      this.inspectionItemQuery = {};
    },
    inspectionItemUpdate(row, loading, done) {
      inspectProjectUpdate(row).then(
        () => {
          done();
          this.inspectionOnLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    inspectionItemSave(row, loading, done) {
      row.equipmentId = this.inspectionItemQuery.equipmentId;
      row.equipmentName = this.inspectionItemQuery.equipmentName;
      inspectProjectAdd(row).then(
        () => {
          loading();
          this.inspectionOnLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    inspectionItemDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return inspectProjectRemove({ ids: row.id });
        })
        .then(() => {
          this.inspectionOnLoad();
          this.$message.success('操作成功!');
        });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    openCllectionItem(row) {
      this.inspectionItemQuery.equipmentId = row.id;
      this.inspectionItemQuery.equipmentName = row.equipmentName;

      this.inspectionOnLoad(this.inspectionItemQuery);
      this.collectionItem = true;
    },
    inspectionItemSearchChange() {
      this.inspectionItemPage.currentPage = 1;
      this.inspectionOnLoad();
    },
    inspectionItemCurrentChange(currentPage) {
      this.inspectionItemPage.currentPage = currentPage;
    },
    inspectionItemSizeChange(pageSize) {
      this.inspectionItemPage.pageSize = pageSize;
    },
    inspectionOnLoad() {
      this.loading = true;
      inspectProjectGetList(
        Object.assign(
          { current: this.inspectionItemPage.currentPage, size: this.inspectionItemPage.pageSize },
          this.inspectionItemQuery
        )
      ).then(({ data }) => {
        this.inspectionItemPage.total = data.total;
        this.inspectionItemData = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
